// extracted by mini-css-extract-plugin
export default {"inviteList":"InviteList_inviteList__W3lB+","inviteImage":"InviteList_inviteImage__C4IzH","inviteIndex":"InviteList_inviteIndex__77UUx","shareButton":"InviteList_shareButton__K1PvP"};